(function(){
  var KEY='cocinabarata_favoritos_v5';
  var memory=[];
  var lastOpener=null;

  function normalise(item){
    if(!item)return null;
    if(typeof item==='string'||typeof item==='number')return{id:String(item),title:'',url:'',image:'',price:''};
    if(!item.id)return null;
    return{id:String(item.id),title:item.title||'',url:item.url||'',image:item.image||'',price:item.price||''};
  }

  function read(){
    try{
      var raw=JSON.parse(localStorage.getItem(KEY)||'[]');
      if(Array.isArray(raw)){
        memory=raw.map(normalise).filter(Boolean);
        return memory.slice();
      }
    }catch(e){}
    return memory.slice();
  }

  function save(items){
    memory=items.slice();
    try{localStorage.setItem(KEY,JSON.stringify(memory));}catch(e){}
  }

  function indexOfId(items,id){
    for(var i=0;i<items.length;i++){
      if(String(items[i].id)===String(id))return i;
    }
    return -1;
  }

  function productFromInput(input){
    var wrapper=input.closest?input.closest('.product-card-wrapper'):null;
    var img=wrapper?wrapper.querySelector('.card__media img'):null;
    var price=wrapper?wrapper.querySelector('.price-item--sale, .price-item--regular'):null;
    return{
      id:String(input.getAttribute('data-product-id')||''),
      title:input.getAttribute('data-product-title')||'Producto',
      url:input.getAttribute('data-product-url')||('/products/'+(input.getAttribute('data-product-handle')||'')),
      image:input.getAttribute('data-product-image')||(img?(img.currentSrc||img.src||''):''),
      price:input.getAttribute('data-product-price')||(price?String(price.textContent||'').replace(/\s+/g,' ').trim():'')
    };
  }

  function productFromButton(button){
    return{
      id:String(button.getAttribute('data-product-id')||''),
      title:button.getAttribute('data-product-title')||'Producto',
      url:button.getAttribute('data-product-url')||('/products/'+(button.getAttribute('data-product-handle')||'')),
      image:button.getAttribute('data-product-image')||'',
      price:button.getAttribute('data-product-price')||''
    };
  }

  function productFromCardButton(button){
    var wrapper=button.closest?button.closest('.product-card-wrapper'):null;
    var img=wrapper?wrapper.querySelector('.card__media img'):null;
    var price=wrapper?wrapper.querySelector('.price-item--sale, .price-item--regular'):null;
    return{
      id:String(button.getAttribute('data-product-id')||''),
      title:button.getAttribute('data-product-title')||'Producto',
      url:button.getAttribute('data-product-url')||('/products/'+(button.getAttribute('data-product-handle')||'')),
      image:img?(img.currentSrc||img.src||''):'',
      price:price?String(price.textContent||'').replace(/\s+/g,' ').trim():''
    };
  }

  function toggleCardButton(button){
    var items=read();
    var product=productFromCardButton(button);
    if(!product.id)return items;
    var index=indexOfId(items,product.id);
    if(index===-1)items.push(product);
    else items.splice(index,1);
    save(items);
    paint(items);
    render(items);
    return items;
  }

  function toggleProductButton(button){
    var items=read();
    var product=productFromButton(button);
    if(!product.id)return items;
    var index=indexOfId(items,product.id);
    if(index===-1)items.push(product);
    else items.splice(index,1);
    save(items);
    paint(items);
    render(items);
    return items;
  }

  function paint(items){
    var inputs=document.querySelectorAll('input[data-cb-wishlist]');
    for(var i=0;i<inputs.length;i++){
      var active=indexOfId(items,inputs[i].getAttribute('data-product-id'))!==-1;
      inputs[i].checked=active;
      inputs[i].setAttribute('aria-checked',active?'true':'false');
      var label=inputs[i].nextElementSibling;
      if(label)label.setAttribute('title',active?'Quitar de favoritos':'Guardar en favoritos');
    }

    var cardButtons=document.querySelectorAll('[data-cb-card-favorite]');
    for(var k=0;k<cardButtons.length;k++){
      var cardSelected=indexOfId(items,cardButtons[k].getAttribute('data-product-id'))!==-1;
      cardButtons[k].classList.toggle('is-selected',cardSelected);
      cardButtons[k].setAttribute('aria-pressed',cardSelected?'true':'false');
      cardButtons[k].setAttribute('title',cardSelected?'Quitar de favoritos':'Guardar en favoritos');
      cardButtons[k].setAttribute('aria-label',(cardSelected?'Quitar ':'Guardar ')+(cardButtons[k].getAttribute('data-product-title')||'producto')+(cardSelected?' de favoritos':' en favoritos'));
    }

    var productButtons=document.querySelectorAll('[data-cb-product-favorite]');
    for(var p=0;p<productButtons.length;p++){
      var selected=indexOfId(items,productButtons[p].getAttribute('data-product-id'))!==-1;
      if(selected)productButtons[p].classList.add('is-selected');
      else productButtons[p].classList.remove('is-selected');
      productButtons[p].setAttribute('aria-pressed',selected?'true':'false');
      productButtons[p].setAttribute('title',selected?'Quitar de favoritos':'Guardar en favoritos');
      productButtons[p].setAttribute('aria-label',(selected?'Quitar ':'Guardar ')+(productButtons[p].getAttribute('data-product-title')||'producto')+(selected?' de favoritos':' en favoritos'));
    }

    var heads=document.querySelectorAll('[data-cb-wishlist-open]');
    for(var h=0;h<heads.length;h++){
      if(items.length)heads[h].classList.add('has-items');
      else heads[h].classList.remove('has-items');
    }

    var counts=document.querySelectorAll('[data-cb-wishlist-count]');
    for(var c=0;c<counts.length;c++){
      counts[c].textContent=String(items.length);
      counts[c].setAttribute('aria-label',String(items.length)+' favoritos');
    }
  }

  function render(items){
    var list=document.querySelector('[data-cb-wishlist-list]');
    if(!list)return;
    list.innerHTML='';

    if(!items.length){
      var empty=document.createElement('div');
      empty.className='cb-wishlist-empty';
      var strong=document.createElement('strong');
      strong.textContent='No tienes favoritos todavía';
      var span=document.createElement('span');
      span.textContent='Pulsa el corazón de un producto para guardarlo aquí.';
      empty.appendChild(strong);
      empty.appendChild(span);
      list.appendChild(empty);
      return;
    }

    for(var i=0;i<items.length;i++){
      var item=items[i];
      var row=document.createElement('article');
      row.className='cb-wishlist-item';

      var photo=document.createElement('a');
      photo.className='cb-wishlist-item-image';
      photo.href=item.url||'#';
      if(item.image){
        var img=document.createElement('img');
        img.src=item.image;
        img.alt=item.title||'Producto favorito';
        img.loading='lazy';
        photo.appendChild(img);
      }

      var copy=document.createElement('div');
      copy.className='cb-wishlist-item-copy';
      var title=document.createElement('a');
      title.href=item.url||'#';
      title.textContent=item.title||'Producto favorito';
      copy.appendChild(title);
      if(item.price){
        var p=document.createElement('span');
        p.textContent=item.price;
        copy.appendChild(p);
      }

      var action=document.createElement('a');
      action.className='cb-wishlist-item-action';
      action.href=item.url||'#';
      action.textContent='CONFIGURAR Y AÑADIR';
      copy.appendChild(action);

      var remove=document.createElement('button');
      remove.type='button';
      remove.className='cb-wishlist-remove';
      remove.setAttribute('data-cb-wishlist-remove',item.id);
      remove.setAttribute('aria-label','Quitar de favoritos');
      remove.textContent='×';

      row.appendChild(photo);
      row.appendChild(copy);
      row.appendChild(remove);
      list.appendChild(row);
    }
  }

  function refresh(){
    var items=read();
    paint(items);
    render(items);
    return items;
  }

  function openDrawer(){
    var drawer=document.querySelector('[data-cb-wishlist-drawer]');
    var overlay=document.querySelector('[data-cb-wishlist-overlay]');
    if(!drawer||!overlay)return;
    var items=refresh();
    lastOpener=document.activeElement;
    overlay.hidden=false;
    window.setTimeout(function(){overlay.classList.add('is-open');},0);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('cb-wishlist-lock');
    var opens=document.querySelectorAll('[data-cb-wishlist-open]');
    for(var i=0;i<opens.length;i++)opens[i].setAttribute('aria-expanded','true');
    var title=drawer.querySelector('#CBWishlistTitle');
    window.setTimeout(function(){if(title)title.focus();},30);
  }

  function closeDrawer(){
    var drawer=document.querySelector('[data-cb-wishlist-drawer]');
    var overlay=document.querySelector('[data-cb-wishlist-overlay]');
    if(!drawer||!overlay)return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cb-wishlist-lock');
    var opens=document.querySelectorAll('[data-cb-wishlist-open]');
    for(var i=0;i<opens.length;i++)opens[i].setAttribute('aria-expanded','false');
    window.setTimeout(function(){
      if(!drawer.classList.contains('is-open'))overlay.hidden=true;
      if(lastOpener&&document.contains(lastOpener)&&lastOpener.focus)lastOpener.focus();
    },220);
  }

  document.addEventListener('pointerdown',function(event){
    var cardButton=event.target.closest?event.target.closest('[data-cb-card-favorite]'):null;
    if(!cardButton)return;
    if(event.pointerType==='mouse'&&event.button!==0)return;
    cardButton.setAttribute('data-cb-card-favorite-pointer','1');
    event.preventDefault();
    event.stopPropagation();
    toggleCardButton(cardButton);
  },true);

  document.addEventListener('click',function(event){
    var cardButton=event.target.closest?event.target.closest('[data-cb-card-favorite]'):null;
    if(!cardButton)return;
    event.preventDefault();
    event.stopPropagation();
    if(cardButton.getAttribute('data-cb-card-favorite-pointer')==='1'){
      cardButton.removeAttribute('data-cb-card-favorite-pointer');
      return;
    }
    toggleCardButton(cardButton);
  },true);

  document.addEventListener('pointerdown',function(event){
    var button=event.target.closest?event.target.closest('[data-cb-product-favorite]'):null;
    if(!button)return;
    button.setAttribute('data-cb-product-favorite-pointer','1');
    event.preventDefault();
    event.stopPropagation();
    toggleProductButton(button);
  },true);

  document.addEventListener('click',function(event){
    var button=event.target.closest?event.target.closest('[data-cb-product-favorite]'):null;
    if(!button)return;
    event.preventDefault();
    event.stopPropagation();
    if(button.getAttribute('data-cb-product-favorite-pointer')==='1'){
      button.removeAttribute('data-cb-product-favorite-pointer');
      return;
    }
    toggleProductButton(button);
  },true);

  document.addEventListener('change',function(event){
    var input=event.target.closest?event.target.closest('input[data-cb-wishlist]'):null;
    if(!input)return;

    var items=read();
    var product=productFromInput(input);
    if(!product.id)return;

    var index=indexOfId(items,product.id);
    if(input.checked&&index===-1)items.push(product);
    if(!input.checked&&index!==-1)items.splice(index,1);

    save(items);
    paint(items);
    render(items);
  },true);

  document.addEventListener('click',function(event){
    var open=event.target.closest?event.target.closest('[data-cb-wishlist-open]'):null;
    if(open){
      event.preventDefault();
      openDrawer();
      return;
    }

    var close=event.target.closest?event.target.closest('[data-cb-wishlist-close], [data-cb-wishlist-overlay]'):null;
    if(close){
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove=event.target.closest?event.target.closest('[data-cb-wishlist-remove]'):null;
    if(remove){
      event.preventDefault();
      var items=read();
      var id=remove.getAttribute('data-cb-wishlist-remove');
      var index=indexOfId(items,id);
      if(index!==-1)items.splice(index,1);
      save(items);
      paint(items);
      render(items);
    }
  },true);

  document.addEventListener('keydown',function(event){
    var drawer=document.querySelector('[data-cb-wishlist-drawer]');
    if(event.key==='Escape'){
      closeDrawer();
      return;
    }
    if(event.key!=='Tab'||!drawer||!drawer.classList.contains('is-open'))return;
    var focusable=drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if(!focusable.length)return;
    var first=focusable[0];
    var last=focusable[focusable.length-1];
    if(event.shiftKey&&document.activeElement===first){
      event.preventDefault();
      last.focus();
    }else if(!event.shiftKey&&document.activeElement===last){
      event.preventDefault();
      first.focus();
    }
  });

  function init(){refresh();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();

  document.addEventListener('shopify:section:load',init);
})();